import {afterNextRender, afterRender, Component, OnInit} from '@angular/core';
import { CommonModule } from '@angular/common';
import {WordpressService} from "../../../services/wordpress.service";
import {SocialNetworks} from "../../../models/Misc/SocialNetworks";

@Component({
  selector: 'social-networks',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './social-networks.component.html',
  styleUrl: './social-networks.component.scss'
})
export class SocialNetworksComponent{
  socialNetworks: SocialNetworks = new SocialNetworks();
  public loading = true;
  constructor(public wp : WordpressService) {
    this.wp.getSocialNetworks().then((sns) => {
      this.socialNetworks = sns;
    });
  }
}
